import { SagaIterator } from 'redux-saga';
import { MODAL_PROFILE_ERROR_CLOSE, MODAL_PROFILE_ERROR_OPEN } from 'src/modules/modals/actions/ModalActions';
import { PROFILE_SYNC_RESET } from 'src/modules/profile/actions/ProfileActions';
import { forceProfileSynchronization } from 'src/modules/profile/sagas/utils/forceProfileSynchronization';
import { getProfileForm } from 'src/modules/profile/selectors/getProfileForm';
import { call, put, select, take } from 'typed-redux-saga';

export function* syncProfile(): SagaIterator<void> {
  const profileForm = yield* select(getProfileForm);

  try {
    yield* call(forceProfileSynchronization, profileForm);
  } catch (error) {
    yield* put(MODAL_PROFILE_ERROR_OPEN.trigger(profileForm));
    yield* take(MODAL_PROFILE_ERROR_CLOSE.is);

    // reset current synchronization status
    yield* put(PROFILE_SYNC_RESET.trigger());
  }
}
